/**
 * NYC marketplace stats (scrapedColivings: region=us, isActive=true).
 * Update after major US scraper runs — round listings down to nearest 4 for stable SEO copy.
 *
 * Last verified: 2026-07-09 — 444 active listings
 */
module.exports = {
  listingsCount: 444,
  listingsLabel: '444+',
  operatorsCount: null,
  operatorsLabel: null,
};
